import React from 'react';
export const CategoriesContext = React.createContext({
  setCategories: (categories) => {},
  categories: [],
});
